import HttpRepository from './httpRepository';

import type { VerifyUserAccessParams } from '../queries/query-keys';
import type { InvitePeople, InvitePeopleWithPhoneNumber, User } from '../zustandStore/slices';
import type { AxiosError, AxiosResponse } from 'axios';

type UserAvatar = {
	avatar: File;
	user: User;
};

const UserRepository = {
	getUser: async () => {
		const response: AxiosResponse<User, AxiosError> = await HttpRepository.tradeshiftGo().get('/rest/user', {});
		return response.data;
	},

	getUserById: async (id: string) => {
		const response = await HttpRepository.tradeshiftGo().get(`/rest/users/${id}`);
		return response.data;
	},

	getUserByEmail: async (email: string) => {
		const response: AxiosResponse<User, AxiosError> = await HttpRepository.tradeshiftGo().get(
			`/rest/users?email=${email}`,
		);
		return response.data;
	},

	sendInvitation: async (user: InvitePeople | InvitePeopleWithPhoneNumber) => {
		let url = '/rest/users/invite';
		if (user.teamId) {
			url = `/rest/teams/${user.teamId}/users/invite`;
		}
		const response: AxiosResponse<User, AxiosError> = await HttpRepository.tradeshiftGo().post(url, user);
		return response.data;
	},

	saveUserData: async (user: User) => {
		const response = await HttpRepository.tradeshiftGo().put(`/rest/users/${user?.userId}`, user);
		return response.data;
	},

	saveAvatar: async ({ avatar, user }: UserAvatar) => {
		const data = new FormData();
		data.append('file', avatar);
		const response = await HttpRepository.tradeshiftGoMulti().put(`/rest/users/${user?.userId}/avatar`, data);
		return response.data;
	},

	verifyAccess: async ({ objectId, operationId, teamId, userId, groupId }: VerifyUserAccessParams) => {
		const url =
			teamId && userId
				? `/rest/teams/${teamId}/users/${userId}/accesslist/operation/${operationId}/object/${objectId}`
				: `/rest/accesslist/operation/${operationId}/object/${objectId}${groupId ? `?groupId=${groupId}` : ''}`;
		const response: AxiosResponse<boolean, AxiosError> = await HttpRepository.tradeshiftGo().get(url);
		return response.data;
	},

	verifyTeamAccess: async ({ teamId, operationId, objectId }) => {
		const response = await HttpRepository.tradeshiftGo().get(
			`/rest/teams/${teamId}/accesslist/operation/${operationId}/object/${objectId}`,
		);
		return response.data;
	},

	getUsersByRoleId: async (roleId: string) => {
		const response = await HttpRepository.tradeshiftGo().get(`/rest/users/role/${roleId}`);
		return response.data;
	},
};

export default UserRepository;
